import { ifyouApi, ADMIN } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';
/** 판매 관리 - 이프유/원데이 패스 관리 */

export const ifyouPassApi = {
  read: () =>
    ifyouApi
      .get(`${ADMIN}/ifyou-pass-list`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  update: (data) =>
    ifyouApi
      .post(`${ADMIN}/ifyou-pass-update`, {
        rows: data,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
